import { ref, readonly } from "vue";

export function useCaptcha() {
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  const executeRecaptcha = async (action: string): Promise<string | null> => {
    if (!window.grecaptcha?.enterprise) {
      error.value = "Google reCAPTCHA not loaded";
      return null;
    }

    try {
      isLoading.value = true;
      error.value = null;

      return new Promise((resolve, reject) => {
        window.grecaptcha.enterprise.ready(async () => {
          try {
            const token = await window.grecaptcha.enterprise.execute(window.RECAPTCHA_V3_SITE_KEY, {
              action,
            });
            resolve(token);
          } catch (err) {
            console.error(err);
            reject(err);
          }
        });
      });
    } catch (err) {
      console.error(err);
      error.value = err instanceof Error ? err.message : "Captcha execution failed";
      return null;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    executeRecaptcha,
    isLoading: readonly(isLoading),
    error: readonly(error),
  };
}
